import React, { Component } from 'react';
import './Pages.css';
import Timeline from '../timeline/Timeline'
import AddCardForm from '../add-card-form/AddCardForm';

class Success extends Component {

  render() {
    return (
      <header>
      <nav>
       <div className="nav-wrapper no-color">
         <a  className="brand-logo center">Completado</a>
       </div>
      </nav>

         <Timeline completed="true"></Timeline>

      <section className="container success">

         <h4>Tu pedido ha sido realizado con éxito!</h4>
         <p>Para hablar con tu rappitendero y ver el estado de tu orden descarga nuestra app o entra a nuestra web</p>

         <div className="buttons row">
          <div className="col s6">
            <a className="waves-effect waves-orange  btn-flat"> <img src="assets/img/googleplay.png"/>  Google Play</a>
          </div>
          <div className="col s6">
            <a className="waves-effect waves-orange  btn-flat apple">  <img src="assets/img/appstore.png"/> App Store</a>
          </div>

          <div className="col s12 web center">
            <a className="waves-effect waves-orange btn-flat">www.rappi.com</a>
          </div>

         </div>
         <div className="brand center">
             <img src="assets/img/logo-rappi.png"/>
         </div>


      </section>

  </header>

    );
  }
}


export default Success;



// WEBPACK FOOTER //
// ./src/components/pages/Success.js